<template>
  <div @blur="isHidden = true;" :tabindex="-1" ref="container">
    <button class="btn btn-link no-outline" @click="isHidden = false; $refs.container.focus()">
      <i class="fa fa-th"></i>
      <div v-show="!isHidden" class="caret animated fadeInDown"></div>
    </button>

    <div v-show="!isHidden" class="custom-popover animated fadeInDown" id="products-popover">
      <div class="popover-body">

        <div class="row">
          <h2>Meus produtos</h2>
          <div class="col-lg-4 text-center ssproduct" v-for="prod in filterProducts(true)" @click="redirect(prod)" v-bind:key="prod.id" :class="{'current-product': currentProductId === prod.id}">
            <img :title="prod.name" :class="prod.id === 'dc162b04e8657157714050bce3908060' ? 'sensor-class': 'img-circle'" :src="prod.img">
            <p>{{ prod.name }}</p>
          </div>
        </div>

        <div class="row">
          <h2>Outros produtos</h2>
          <div class="col-lg-4 text-center ssproduct" v-for="prod in filterProducts(false)" @click="redirect(prod)" v-bind:key="prod.id">
            <img :title="prod.name" :class="prod.id === 'dc162b04e8657157714050bce3908060' ? 'sensor-class': 'img-circle'" :src="prod.img">
            <p>{{ prod.name }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { productSwitch } from '../../mixins/product-switch'

export default {
  mixins: [productSwitch],

  data() {
    return {
      isHidden: true,
      products: []
    };
  },

  methods: {
    filterProducts(enabled) {
      return this.products.filter(product => product.enabled === enabled)
    },

    redirect(product) {
      this.switchTo(product.id)
      this.isHidden = true
    }
  },

  mounted() {
    this.products = this.$data._products // pega os produtos do mixin
  }
}
</script>

<style scoped>
.no-outline, .no-outline:hover, .no-outline:focus { outline: none; }
.custom-popover {
  width: 300px;
  background: #fff;
  padding: 15px;
  border: 1px solid #ccc;
  border-color: rgba(0,0,0,.2);
  box-shadow: 0 2px 10px rgba(0,0,0,.2);
  outline: none;
  right: -50px;
  top: 40px;
  border-radius: 2px;
  position: absolute;
  z-index: 1700;
}
.caret {
  border-color: transparent;
  border-bottom-color: #fff;
  border-style: dashed dashed solid;
  border-width: 0 12px 12px;
  position: absolute;
  left: 0px;
  top: 29px;
  z-index: 1701;
  height: 0;
  width: 0;
}
.popover-body { padding: 0 15px; }
.popover-body h2 { font-size: 18px; margin: 10px 0 5px 0; }
.ssproduct {
  padding: 10px;
  border: solid 1px transparent;
  border-radius: 3px;
  height: 100px;
  cursor: pointer;
}
.current-product.ssproduct { background-color: #F5F5F5; }
.ssproduct:hover { border: solid 1px #ddd; }
.img-circle {
  max-width: 40px;
  margin-bottom: 8px;
}
.sensor-class {
  max-width: 70px;
  min-width: 70px;
  height: 50px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/ProductsPopover.vue